import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DatePicker from '@mui/lab/DatePicker'

const Datepicker = (props) => {
  const { className, label, name, size, control, required } = props

  return (
    <div className={`${className === '' ? '' : (' ' + className)}`}>
      <Controller
        name={name}
        control={control}
        rules={{ required: required }}
        render={({ field: { onChange, value } }) => {
          return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label={label}
                value={value || null}
                inputFormat="dd-MM-yyyy"
                mask="__-__-____"
                onChange={onChange}
                renderInput={(params) => <TextField {...params} size={size} fullWidth />}
              />
            </LocalizationProvider>
          )
        }}
      />
    </div>
  )
}

Datepicker.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  required: PropTypes.bool,
  control: PropTypes.any
}

Datepicker.defaultProps = {
  className: '',
  label: '',
  name: '',
  size: 'small',
  required: false
}

export default Datepicker
